<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Gastrology Department</h2>
      <p>
        The Department of Gastrology specializes in the diagnosis and treatment
        of disorders affecting the digestive system, including the stomach,
        liver, pancreas, and intestines. Our team of gastroenterologists
        provides advanced care for conditions such as acidity, ulcers, IBS,
        fatty liver, jaundice, and gastrointestinal bleeding.
      </p>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <img
          src="@/assets/img/departments/Gastroenterologist.jpg"
          alt="Gastrology Department"
          class="img-thumbnail img-thumbnail-box"
        />
      </div>
      <div class="col-lg-8">
        <p><strong>Department of Gastrology</strong></p>
        <p>
          We are equipped with modern endoscopy and colonoscopy units for both
          diagnostic and therapeutic procedures. The department offers
          evidence-based treatment protocols combined with dietary counseling
          and lifestyle modification guidance.
        </p>
        <p>
          Patients are evaluated through detailed assessments and imaging for
          accurate diagnosis and effective management. Specialized clinics for
          liver disease, pancreatitis, and nutritional disorders function under
          the department.
        </p>
        <p>
          Preventive gastro care through awareness programs and regular
          check-ups helps in early detection of serious gastrointestinal
          conditions. Our goal is to ensure optimal digestive health and
          long-term well-being for every patient.
        </p>
      </div>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate3.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Gastrology Doctors',
      queryName: 'Gastrology',
      teamName: 'Gastrology team',
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import '@/scss/sectionTemplate2.scss';
</style>
